(() => {
  const labelsElement = document.getElementById('blaw-sharing-labels');
  if (!labelsElement) return;
  const labels = JSON.parse(labelsElement.textContent);
  let panelSequence = 0;

  document.querySelectorAll('[data-product-share]').forEach(scope => {
    const area = scope.closest('.product-block-area');
    if (!area) return;
    const alignActions = () => {
      const wishlist = area.querySelector('wishlist-button-block');
      if (!wishlist || scope.contains(wishlist)) return;
      let wrapper = wishlist;
      while (wrapper.parentElement && wrapper.parentElement !== area) wrapper = wrapper.parentElement;
      if (wrapper.parentElement !== area) return;
      wrapper.classList.add('blaw-product-actions__wishlist');
      scope.classList.add('blaw-product-actions', 'max-w-2xl');
      scope.prepend(wrapper);
    };
    alignActions();
    new MutationObserver(alignActions).observe(area, {childList:true, subtree:true});
  });

  const setLink = (scope, url, title, message) => {
    scope.dataset.readyUrl = url;
    scope.dataset.readyTitle = title;
    scope.dataset.readyMessage = message;
    scope.querySelector('[data-share-url-field]').value = url;
    scope.querySelector('[data-share-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(message + '\n' + url);
    scope.querySelector('[data-share-email]').href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(message + '\n\n' + url);
    scope.querySelector('[data-share-native]').hidden = typeof navigator.share !== 'function';
  };

  const productLink = scope => {
    const url = new URL(scope.dataset.shareUrl, location.origin);
    const content = scope.closest('.product-content-container');
    const variant = content?.querySelector('form input[name="id"]')?.value || new URL(location.href).searchParams.get('variant');
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
    return url.href;
  };

  const wishlistLink = scope => {
    const page = scope.closest('wishlist-page');
    const original = page?.querySelector('wishlist-share');
    const id = original?.wishlist?.publicId;
    if (!id || id === 'mine' || !original?.app?.utils?.url?.getPublicWishlistUrl) return null;
    return original.app.utils.url.getPublicWishlistUrl(id);
  };

  const copy = async scope => {
    const status = scope.querySelector('[data-share-status]');
    try {
      await navigator.clipboard.writeText(scope.dataset.readyUrl);
      status.textContent = labels.copied;
    } catch {
      const field = scope.querySelector('[data-share-url-field]');
      field.focus();
      field.select();
      status.textContent = labels.manual;
    }
  };

  const refreshProduct = scope => {
    if (scope.hasAttribute('data-product-share') && scope.dataset.readyUrl) {
      setLink(scope, productLink(scope), scope.dataset.shareTitle, labels.product_message + ' ' + scope.dataset.shareTitle);
    }
  };

  document.addEventListener('change', () => {
    requestAnimationFrame(() => document.querySelectorAll('[data-product-share]').forEach(refreshProduct));
  });

  document.addEventListener('click', async event => {
    const target = event.target.closest('[data-share-trigger], [data-share-copy], [data-share-native]');
    if (!target) return;
    const scope = target.closest('.blaw-share');
    if (!scope) return;
    if (target.hasAttribute('data-share-trigger')) {
      const panel = scope.querySelector('[data-share-panel]');
      if (!panel.id) panel.id = 'blaw-share-panel-' + (++panelSequence);
      target.setAttribute('aria-controls', panel.id);
      if (!panel.hidden) {
        panel.hidden = true;
        target.setAttribute('aria-expanded', 'false');
        return;
      }
      panel.hidden = false;
      target.setAttribute('aria-expanded', 'true');
      const isWishlist = scope.classList.contains('blaw-share--wishlist');
      const url = isWishlist ? wishlistLink(scope) : productLink(scope);
      if (!url) {
        scope.querySelector('[data-share-status]').textContent = labels.loading;
        return;
      }
      const title = isWishlist ? labels.wishlist_title : scope.dataset.shareTitle;
      const message = isWishlist ? labels.wishlist_message : labels.product_message + ' ' + title;
      setLink(scope, url, title, message);
      await copy(scope);
    } else if (target.hasAttribute('data-share-copy') && scope.dataset.readyUrl) {
      refreshProduct(scope);
      await copy(scope);
    } else if (target.hasAttribute('data-share-native') && scope.dataset.readyUrl) {
      refreshProduct(scope);
      try {
        await navigator.share({url: scope.dataset.readyUrl, title: scope.dataset.readyTitle, text: scope.dataset.readyMessage});
      } catch (error) {
        if (error.name !== 'AbortError') scope.querySelector('[data-share-status]').textContent = labels.manual;
      }
    }
  });

  const mountWishlist = () => {
    const page = document.querySelector('wishlist-page');
    const template = document.getElementById('blaw-wishlist-share-template');
    if (!page || !template) return false;
    const mount = () => {
      const header = page.querySelector('.wk-header');
      if (!header || header.querySelector('.blaw-share')) return;
      if (!header.querySelector('wishlist-share')) return;
      header.append(template.content.cloneNode(true));
      header.classList.add('blaw-wishlist-ready');
    };
    mount();
    new MutationObserver(mount).observe(page, {childList:true, subtree:true});
    return true;
  };
  if (!mountWishlist() && document.getElementById('blaw-wishlist-share-template')) {
    const main = document.getElementById('MainContent');
    if (main) {
      const observer = new MutationObserver(() => { if (mountWishlist()) observer.disconnect(); });
      observer.observe(main, {childList:true, subtree:true});
    }
  }
})();

